export default "__VITE_ASSET__EU9NrTph__"